import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import {
  Ch_updateProgressNotePointOfCareInput,
  chUpdateProgressNotePointOfCareMutation,
  chUpdateProgressNotePointOfCareMutation$data,
} from "@/modules/patients/services/ch/__generated__/chUpdateProgressNotePointOfCareMutation.graphql"
import { chUpdateProgressNotePointOfCare } from "@/modules/patients/services/ch/chUpdateProgressNotePointOfCareMutation"
import {
  De_updateProgressNotePointOfCareInput,
  deUpdateProgressNotePointOfCareMutation,
  deUpdateProgressNotePointOfCareMutation$data,
} from "@/modules/patients/services/de/__generated__/deUpdateProgressNotePointOfCareMutation.graphql"
import { deUpdateProgressNotePointOfCare } from "@/modules/patients/services/de/deUpdateProgressNotePointOfCareMutation"
import { Country } from "@/types/__generated__/union-types"

export function useUpdateProgressNotePointOfCareMutation(
  country: Country,
): (
  input: Ch_updateProgressNotePointOfCareInput & De_updateProgressNotePointOfCareInput,
  handleComplete?: (
    response: chUpdateProgressNotePointOfCareMutation$data | deUpdateProgressNotePointOfCareMutation$data,
  ) => void,
  handleError?: (
    response: chUpdateProgressNotePointOfCareMutation$data | deUpdateProgressNotePointOfCareMutation$data,
  ) => void,
) => void {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chUpdateProgressNotePointOfCare
      case "DE":
        return deUpdateProgressNotePointOfCare
    }
  })()

  const [commit] = useMutationWithErrorToast<
    chUpdateProgressNotePointOfCareMutation & deUpdateProgressNotePointOfCareMutation
  >(mutation)

  return useCallback(
    (
      input: Ch_updateProgressNotePointOfCareInput & De_updateProgressNotePointOfCareInput,
      handleComplete?: (
        response: chUpdateProgressNotePointOfCareMutation$data | deUpdateProgressNotePointOfCareMutation$data,
      ) => void,
      handleError?: (
        response: chUpdateProgressNotePointOfCareMutation$data | deUpdateProgressNotePointOfCareMutation$data,
      ) => void,
    ) => {
      commit({
        variables: { input },
        onCompleted: (
          response: chUpdateProgressNotePointOfCareMutation$data & deUpdateProgressNotePointOfCareMutation$data,
        ) => {
          const { errors } = response.updateProgressNotePointOfCare
          if (!errors?.length) {
            handleComplete?.(response)
          } else {
            handleError?.(response)
          }
        },
      })
    },
    [commit],
  )
}
